import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState<"loading" | "valid" | "already" | "invalid" | "done" | "error">("loading");
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (!token) { setStatus("invalid"); return; }
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const anonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
    fetch(`${supabaseUrl}/functions/v1/handle-email-unsubscribe?token=${token}`, {
      headers: { apikey: anonKey },
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.valid === false && data.reason === "already_unsubscribed") setStatus("already");
        else if (data.valid) setStatus("valid");
        else setStatus("invalid");
      })
      .catch(() => setStatus("error"));
  }, [token]);

  const handleConfirm = async () => {
    if (!token) return;
    setProcessing(true);
    try {
      const { supabase } = await import("@/integrations/supabase/client");
      const { data } = await supabase.functions.invoke("handle-email-unsubscribe", { body: { token } });
      if (data?.success) setStatus("done");
      else if (data?.reason === "already_unsubscribed") setStatus("already");
      else setStatus("error");
    } catch { setStatus("error"); }
    setProcessing(false);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-card rounded-2xl p-8 text-center shadow-lg">
        {status === "loading" && <p className="text-muted-foreground">Verifying…</p>}
        {status === "valid" && (
          <>
            <h1 className="font-heading text-2xl font-bold text-foreground mb-3">Unsubscribe</h1>
            <p className="text-muted-foreground mb-6 text-sm">Are you sure you want to unsubscribe from Greenleaf Digital emails?</p>
            <button onClick={handleConfirm} disabled={processing} className="bg-primary text-primary-foreground px-6 py-3 rounded-lg font-semibold text-sm hover:opacity-90 transition disabled:opacity-50">
              {processing ? "Processing…" : "Confirm Unsubscribe"}
            </button>
          </>
        )}
        {status === "done" && (
          <>
            <h1 className="font-heading text-2xl font-bold text-foreground mb-3">Unsubscribed</h1>
            <p className="text-muted-foreground text-sm">You've been successfully unsubscribed.</p>
          </>
        )}
        {status === "already" && (
          <>
            <h1 className="font-heading text-2xl font-bold text-foreground mb-3">Already Unsubscribed</h1>
            <p className="text-muted-foreground text-sm">This email has already been unsubscribed.</p>
          </>
        )}
        {status === "invalid" && (
          <>
            <h1 className="font-heading text-2xl font-bold text-foreground mb-3">Invalid Link</h1>
            <p className="text-muted-foreground text-sm">This unsubscribe link is invalid or has expired.</p>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="font-heading text-2xl font-bold text-foreground mb-3">Something Went Wrong</h1>
            <p className="text-muted-foreground text-sm">Please try again later.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default Unsubscribe;
